import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { initGA, logPageView } from '../utils/analytics';

export default function GoogleAnalytics({ consentGranted }) {
  const location = useLocation();
  const measurementId = process.env.REACT_APP_GA_MEASUREMENT_ID;
  const googleAdsId = process.env.REACT_APP_GOOGLE_ADS_CONVERSION_ID;

  useEffect(() => {
    // Initialize GA on mount, only once the visitor has consented
    if (consentGranted && measurementId) {
      if (!window.gtag) {
        initGA(measurementId, googleAdsId);
      }
    }
  }, [consentGranted, measurementId, googleAdsId]);

  useEffect(() => {
    // Track page views on route change
    if (consentGranted && measurementId && window.gtag) {
      logPageView(location.pathname + location.search, measurementId);
    }
  }, [location, consentGranted, measurementId]);

  return null;
}
